<dx-box #workflowUserMetrics height="100%" width="100%" direction="col">
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <h2 class="page-header">
                AAP Workflow Metrics
                <sup class="page-help-link">
                    <a [href]="helpLink" target="_blank" class="fas fa-question-circle"></a>
                </sup>
            </h2>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1">
        <div *dxTemplate>
            <dx-box width="100%" height="100%" direction="col" class="user-metrics-container cc-white-background">
                <dxi-item baseSize="auto">
                    <div *dxTemplate>
                        <dx-form
                            width="100%"
                            height="100%"
                            [labelLocation]="labelLocation"
                            [showColonAfterLabel]="true"
                            [colCount]="1"
                            class="user-metrics-form"
                        >
                            <dxi-item itemType="group" [colCount]="5" cssClass="form-alignment">
                                <dxi-item>
                                    <dxo-label text="Company"></dxo-label>
                                    <div *dxTemplate class="field-component">
                                        <dx-select-box
                                            displayExpr="companyName"
                                            valueExpr="companyId"
                                            placeholder="All Companies"
                                            [disabled]="companyList?.length === 1"
                                            [elementAttr]="{ class: 'metrics-component' }"
                                            [showClearButton]="true"
                                            [searchEnabled]="true"
                                            [dataSource]="companyList"
                                            [(value)]="metricsParam.companyId"
                                            (onValueChanged)="onCompanyValueChange()"
                                        ></dx-select-box>
                                    </div>
                                </dxi-item>
                                <dxi-item>
                                    <dxo-label text="AAP Staff"></dxo-label>
                                    <div *dxTemplate class="field-component">
                                        <dx-select-box
                                            displayExpr="displayName"
                                            valueExpr="id"
                                            placeholder="All Staff"
                                            [disabled]="aapUserList?.length === 1"
                                            [elementAttr]="{ class: 'metrics-component' }"
                                            [showClearButton]="true"
                                            [searchEnabled]="true"
                                            [dataSource]="aapUserList"
                                            [(value)]="metricsParam.aapUserId"
                                        ></dx-select-box>
                                    </div>
                                </dxi-item>
                                <dxi-item>
                                    <dxo-label text="Begin Date"></dxo-label>
                                    <div *dxTemplate class="field-component">
                                        <dx-date-box
                                            #fromDAte
                                            type="date"
                                            [max]="maxDate"
                                            [showClearButton]="true"
                                            [elementAttr]="{ class: 'metrics-component' }"
                                            [(value)]="metricsParam.fromDate"
                                        ></dx-date-box>
                                    </div>
                                </dxi-item>
                                <dxi-item>
                                    <dxo-label text="End Date"></dxo-label>
                                    <div *dxTemplate class="field-component">
                                        <dx-date-box
                                            #toDate
                                            type="date"
                                            [max]="maxDate"
                                            [showClearButton]="true"
                                            [elementAttr]="{ class: 'metrics-component' }"
                                            [(value)]="metricsParam.toDate"
                                        ></dx-date-box>
                                    </div>
                                </dxi-item>
                                <dxi-item>
                                    <div *dxTemplate class="field-component">
                                        <dx-button
                                            type="default"
                                            text="Refresh"
                                            [icon]="iconRefresh"
                                            [tabIndex]="-1"
                                            (onClick)="onRefreshClick()"
                                        ></dx-button>
                                    </div>
                                </dxi-item>
                            </dxi-item>
                        </dx-form>
                    </div>
                </dxi-item>
                <dxi-item [ratio]="1">
                    <div *dxTemplate>
                        <cc-data-grid-features
                            *ngIf="!!userMetrics"
                            [stateConfig]="{ storageKey: 'WORKFLOW_USER_METRICS_GRID', storeGroupings: false }"
                            [gridFeatures]="{ allowGrouping: false }"
                            [dataSource]="userMetrics"
                        >
                            <dx-data-grid
                                width="100%"
                                height="100%"
                                class="cc-vertical-center-cell-data-grid"
                                [dataSource]="userMetrics"
                            >
                                <dxi-column
                                    dataField="aapUserDisplayText"
                                    dataType="string"
                                    caption="Processor"
                                    cellTemplate="userDisplayTemplate"
                                ></dxi-column>
                                <dxi-column
                                    dataField="totalProcessedCount"
                                    dataType="number"
                                    caption="Total Processed"
                                    cellTemplate="valueHyperlinkTemplate"
                                ></dxi-column>
                                <dxi-column
                                    dataField="totalScannedStepCount"
                                    dataType="number"
                                    caption="Total Scanned"
                                    cellTemplate="valueHyperlinkTemplate"
                                ></dxi-column>
                                <dxi-column
                                    dataField="totalVerifyStepCount"
                                    dataType="number"
                                    caption="Total Verified"
                                    cellTemplate="valueHyperlinkTemplate"
                                ></dxi-column>
                                <dxi-column
                                    dataField="totalSupervisorStepCount"
                                    dataType="number"
                                    caption="Total Resolved"
                                    cellTemplate="valueHyperlinkTemplate"
                                ></dxi-column>
                                <dxi-column
                                    dataField="totalDeletedCount"
                                    dataType="number"
                                    caption="Total Deleted"
                                    cellTemplate="valueHyperlinkTemplate"
                                ></dxi-column>
                                <dxi-column
                                    dataField="totalSentToVendorEditCount"
                                    dataType="number"
                                    caption="Total Vendor Edit"
                                    cellTemplate="valueHyperlinkTemplate"
                                ></dxi-column>
                                <dxi-column
                                    dataField="totalMismatchCount"
                                    dataType="number"
                                    caption="Total Mismatched"
                                    cellTemplate="valueHyperlinkTemplate"
                                ></dxi-column>

                                <div *dxTemplate="let row of 'userDisplayTemplate'">
                                    <app-user-bio-link [user]="row.data.aapUser"></app-user-bio-link>
                                </div>

                                <div *dxTemplate="let row of 'valueHyperlinkTemplate'">
                                    <app-hyperlink-creator
                                        *ngIf="row.value > 0"
                                        [displayText]="row.value"
                                        (onLinkClick)="onShowUserMetricsDetail(row)"
                                    ></app-hyperlink-creator>
                                </div>
                                <dxo-summary>
                                    <dxi-total-item
                                        showInColumn="aapUser"
                                        alignment="center"
                                        displayFormat="Total"
                                    ></dxi-total-item>
                                    <dxi-total-item
                                        column="totalProcessedCount"
                                        name="totalProcessedCount"
                                        summaryType="sum"
                                        dataType="number"
                                        displayFormat="{0}"
                                    ></dxi-total-item>
                                    <dxi-total-item
                                        column="totalScannedStepCount"
                                        name="totalScannedStepCount"
                                        summaryType="sum"
                                        dataType="number"
                                        displayFormat="{0}"
                                    ></dxi-total-item>
                                    <dxi-total-item
                                        column="totalVerifyStepCount"
                                        name="totalVerifyStepCount"
                                        summaryType="sum"
                                        dataType="number"
                                        displayFormat="{0}"
                                    ></dxi-total-item>
                                    <dxi-total-item
                                        column="totalSupervisorStepCount"
                                        name="totalSupervisorStepCount"
                                        summaryType="sum"
                                        dataType="number"
                                        displayFormat="{0}"
                                    ></dxi-total-item>
                                    <dxi-total-item
                                        column="totalDeletedCount"
                                        name="totalDeletedCount"
                                        summaryType="sum"
                                        displayFormat="{0}"
                                    ></dxi-total-item>
                                    <dxi-total-item
                                        column="totalSentToVendorEditCount"
                                        name="totalSentToVendorEditCount"
                                        summaryType="sum"
                                        dataType="number"
                                        displayFormat="{0}"
                                    ></dxi-total-item>
                                    <dxi-total-item
                                        column="totalMismatchCount"
                                        name="totalMismatchCount"
                                        summaryType="sum"
                                        dataType="number"
                                        displayFormat="{0}"
                                    ></dxi-total-item>
                                </dxo-summary>
                            </dx-data-grid>
                        </cc-data-grid-features>
                    </div>
                </dxi-item>
            </dx-box>
        </div>
    </dxi-item>
</dx-box>

<app-workflow-user-metrics-detail
    *ngIf="showDetailPopup"
    [title]="metricDetailPopupTitle"
    [metricType]="selectedMetricType"
    [detailSource]="selectedUserMetricRecord?.detailsByDate"
    (onClose)="onMetricsDetailClose()"
></app-workflow-user-metrics-detail>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#workflowUserMetrics' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
